export { default } from "./skeleton"
